import { useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import axios from 'axios';
import useModalStore from '../zustand/store/useModalStore';
import { isAuthExiting } from '../component/AxiosCORS';

const SessionCheck = () => {

    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    };

    const navigate = useNavigate();
    const { pathname } = useLocation();
    const token = getCookie('accessToken');
    const userId = localStorage.getItem('id');

    const showNotiModal = useModalStore(state => state.showNotiModal);

    const sessionCheck = async () => {
        let response;
        try {
            response = await axios.get('/commonapi/sessionCheckRedis.do');
        } catch (e) {
            // 401(중복로그인 등)은 전역 axios 인터셉터가 안내·이동을 맡는다. 여기서는 삼킨다.
            // 잡지 않으면 처리되지 않은 Promise 오류가 되어 개발 서버에서는 오류 화면이 덮는다.
            return;
        }
        const token = response.data.token;
        
        if (!userId || !token) {
            showNotiModal(`${!userId ? '로그인 정보가 없습니다.' : '세션이 만료되었습니다.'}` + '\n로그인 페이지로 이동합니다.');
            navigate('/member/login.do', { state: pathname });
        };

    };

    useEffect(() => {
        // 전역 axios 인터셉터가 401을 받아 안내 모달을 띄운 상태면 여기서 또 알리지 않는다.
        // 사유가 같은 모달이 두 번 뜨는 것을 막는다. 알림과 이동은 인터셉터가 담당한다.
        if (isAuthExiting()) return;

        if(pathname !== '/member/login.do') sessionCheck();
    }, [pathname]);

    return (
        <>{token !== null ? <Outlet /> : ''}</>
    );
};

export default SessionCheck;